import { bindable } from 'aurelia-framework';
import { IImportAM } from './import-api';

export class ImportSourceView {
	@bindable importEntry: IImportAM;
}
